<template>
  <div>
    <!-- MisVisitasView -->
  </div>
</template>

<script>
export default {
  name: 'MisVisitasView'
}
</script>



// WEBPACK FOOTER //
// src/views/clientes/MisVisitasView.vue